import { Loader2Icon } from "lucide-react";
export function Loader() {
  return <div className="flex h-full w-full items-center justify-center" data-sentry-component="Loader" data-sentry-source-file="loader.tsx">
      <Loader2Icon className="text-primary h-28 w-28 animate-spin" data-sentry-element="Loader2Icon" data-sentry-source-file="loader.tsx" />
    </div>;
}